export const breakpoints = [768, 1024, 1440];
export const MEDIA_QUERY_BREAKPOINTS = {
    mobile: breakpoints[0],
    tablet: breakpoints[1],
    desktop: breakpoints[2],
};
export const DIRECTION_UP = 'ArrowUp';
export const DIRECTION_DOWN = 'ArrowDown';
export const DIRECTION_LEFT = 'ArrowLeft';
export const DIRECTION_RIGHT = 'ArrowRight';
export const ENTER_KEY = 'Enter';
export const DISPLAY_DATE_FORMAT = 'd MMM';
export const DISPLAY_FULL_DATE_FORMAT = 'd MMM yyyy';
export const LAYERS = {
    farBackground: -20,
    background: -10,
    midground: 0,
    foreground: 10,
    nearForeground: 20,
};
//# sourceMappingURL=react.types.js.map